/* rpg-skyrim.js — atmosphere + a whole pile of easter eggs, site-wide.
   Snow · dragon shouts (type them) · Konami unlock · logo clicks · sweetroll
   rain · idle guard lines · achievements · console wink. Reduced-motion safe. */
(function () {
  'use strict';
  if (!document.body.classList.contains('sky-world')) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- falling snow ---------- */
  (function snow() {
    if (reduce) return;
    var c = document.createElement('canvas'); c.className = 'sk-snow'; document.body.appendChild(c);
    var x = c.getContext('2d'), w, h, f = [];
    function sz() { w = c.width = innerWidth; h = c.height = innerHeight; } sz(); addEventListener('resize', sz);
    for (var i = 0; i < Math.min(90, innerWidth / 16); i++) f.push({ x: Math.random() * w, y: Math.random() * h, r: Math.random() * 1.6 + .4, s: Math.random() * .5 + .2, d: Math.random() * .6 });
    (function d() { x.clearRect(0, 0, w, h); x.fillStyle = 'rgba(210,218,226,.7)'; for (var i = 0; i < f.length; i++) { var q = f[i]; x.beginPath(); x.arc(q.x, q.y, q.r, 0, 6.283); x.fill(); q.y += q.s; q.x += Math.sin(q.y * .01 + q.d) * .3; if (q.y > h + 4) { q.y = -4; q.x = Math.random() * w; } } requestAnimationFrame(d); })();
  })();

  /* ---------- achievement / toast ---------- */
  function toast(msg, icon) {
    var el = document.createElement('div'); el.className = 'sk-toast';
    el.innerHTML = (icon ? '<b style="color:var(--sk-silver2);margin-right:8px">' + icon + '</b>' : '') + msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    setTimeout(function () { el.classList.remove('is-on'); setTimeout(function () { el.remove(); }, 400); }, 3800);
  }
  window.RPGToast = toast;

  /* ---------- Skyrim "skill increased" notification ---------- */
  var SKILLS = ['DRIP', 'HAGGLING', 'STYLE', 'SPEECH', 'LIGHT ARMOR', 'SNEAK', 'ENCHANTING', 'RESTORATION'];
  var skillBar;
  function skillUp() {
    var name = SKILLS[Math.floor(Math.random() * SKILLS.length)];
    var lvl = 40 + Math.floor(Math.random() * 61);
    if (!skillBar) { skillBar = document.createElement('div'); skillBar.className = 'sk-skill'; skillBar.innerHTML = '<span class="sk-skill__t"></span><span class="sk-skill__bar"><span></span></span>'; document.body.appendChild(skillBar); }
    skillBar.querySelector('.sk-skill__t').textContent = name + ' increased to ' + lvl;
    var f = skillBar.querySelector('.sk-skill__bar span'); f.style.transition = 'none'; f.style.width = '0';
    skillBar.classList.remove('is-on'); void skillBar.offsetWidth; skillBar.classList.add('is-on');
    requestAnimationFrame(function () { f.style.transition = 'width 1.1s var(--rpg-ease)'; f.style.width = lvl + '%'; });
    clearTimeout(skillUp._t); skillUp._t = setTimeout(function () { skillBar.classList.remove('is-on'); }, 2900);
  }
  window.RPGSkillUp = skillUp;

  /* ---------- absorb-soul wisps (desktop) ----------
     On add-to-inventory, streams of light rise from the button and
     get pulled into the cart icon — the Skyrim soul-absorb beat. */
  function absorbSoul(origin) {
    if (!window.matchMedia) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;      // desktop only
    if (typeof document.body.animate !== 'function') return;         // needs WAAPI
    var target = document.querySelector('#cart-icon-bubble') ||
                 document.querySelector('.header__icon--cart') ||
                 document.querySelector('a[href$="/cart"]');
    var o = (origin && origin.getBoundingClientRect) ? origin.getBoundingClientRect() : null;
    if (!o) return;
    var t = target ? target.getBoundingClientRect() : { left: window.innerWidth - 44, top: 18, width: 24, height: 24 };
    var sx = o.left + o.width / 2, sy = o.top + o.height / 2;
    var tx = t.left + t.width / 2, ty = t.top + t.height / 2;
    var dx = tx - sx, dy = ty - sy;
    for (var i = 0; i < 14; i++) {
      (function (i) {
        var el = document.createElement('span');
        el.className = 'sk-soul';
        document.body.appendChild(el);
        var jx = (Math.random() - 0.5) * 80;
        var lift = -30 - Math.random() * 60;
        el.style.transform = 'translate(' + sx + 'px,' + sy + 'px)';
        var anim = el.animate([
          { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(1)', opacity: 0 },
          { opacity: 0.95, offset: 0.18 },
          { transform: 'translate(' + (sx + dx * 0.5 + jx) + 'px,' + (sy + dy * 0.5 + lift) + 'px) scale(0.85)', opacity: 0.85, offset: 0.55 },
          { transform: 'translate(' + tx + 'px,' + ty + 'px) scale(0.2)', opacity: 0 }
        ], { duration: 780 + Math.random() * 320, delay: i * 26, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
        anim.onfinish = function () { el.remove(); };
      })(i);
    }
  }
  window.RPGAbsorbSoul = absorbSoul;

  /* ---------- the shout ---------- */
  var shout;
  function doShout(word, grad) {
    if (!shout) { shout = document.createElement('div'); shout.className = 'sk-shout'; shout.innerHTML = '<span class="sk-shout__w"></span>'; document.body.appendChild(shout); }
    var wEl = shout.querySelector('.sk-shout__w');
    wEl.textContent = word;
    wEl.style.background = grad || ''; wEl.style.webkitBackgroundClip = grad ? 'text' : ''; wEl.style.backgroundClip = grad ? 'text' : '';
    shout.classList.remove('is-on'); void shout.offsetWidth; shout.classList.add('is-on');
    if (!reduce) document.documentElement.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-7px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 280 });
    clearTimeout(doShout._t); doShout._t = setTimeout(function () { shout.classList.remove('is-on'); }, 2000);
  }

  /* ---------- sweetroll rain ---------- */
  function rain(emoji) {
    if (reduce) { toast('no one will steal your sweetroll.', '🍩'); return; }
    for (var i = 0; i < 24; i++) (function (i) {
      var s = document.createElement('div'); s.textContent = emoji; s.style.cssText = 'position:fixed;top:-40px;z-index:9997;pointer-events:none;font-size:' + (18 + Math.random() * 22) + 'px;left:' + (Math.random() * 100) + 'vw;';
      document.body.appendChild(s);
      s.animate([{ transform: 'translateY(-40px) rotate(0deg)', opacity: 1 }, { transform: 'translateY(' + (innerHeight + 80) + 'px) rotate(' + (Math.random() * 720 - 360) + 'deg)', opacity: .9 }], { duration: 2600 + Math.random() * 1500, delay: i * 60, easing: 'ease-in' }).onfinish = function () { s.remove(); };
    })(i);
  }

  /* ---------- typed words ---------- */
  var SHOUTS = {
    fus: ['FUS RO DAH', 'linear-gradient(180deg,#ffffff,#e6ebf0 45%,#b6bfca)'],
    yol: ['YOL TOOR SHUL', 'linear-gradient(180deg,#ffe6c2,#ff9a4d 45%,#e0631f)'],
    iiz: ['IIZ SLEN NUS', 'linear-gradient(180deg,#f2ffff,#c2eeff 45%,#72c2e8)'],
    feim: ['FEIM ZII GRON', 'linear-gradient(180deg,#f0f3ff,#cbd4f0 45%,#98a8d2)'],
    dovahkiin: ['DOVAHKIIN', 'linear-gradient(180deg,#ffffff,#f0d896 45%,#cda24a)']
  };
  var buf = '';
  addEventListener('keydown', function (e) {
    var t = e.target; if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
    if (!/^[a-z]$/i.test(e.key)) return;
    buf = (buf + e.key.toLowerCase()).slice(-12);
    for (var k in SHOUTS) if (buf.endsWith(k)) { doShout(SHOUTS[k][0], SHOUTS[k][1]); if (k === 'dovahkiin') toast('you are the dragonborn.', '🐉'); return; }
    if (buf.endsWith('sweetroll')) rain('🍩');
    else if (buf.endsWith('arrow')) toast('I used to be an adventurer like you...', '🏹');
    else if (buf.endsWith('cheese')) rain('🧀');
  }, { passive: true });

  /* ---------- Konami -> unlock ---------- */
  (function () {
    var SEQ = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65], pos = 0, code = window.RPG_EGG_CODE || 'CONSOLE';
    addEventListener('keydown', function (e) {
      var t = e.target; if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
      pos = (e.keyCode === SEQ[pos]) ? pos + 1 : (e.keyCode === SEQ[0] ? 1 : 0);
      if (pos === SEQ.length) { pos = 0; try { navigator.clipboard && navigator.clipboard.writeText(code); } catch (x) {} toast('CHEAT ENABLED · code "' + code + '" copied · 15% off', '⌘'); }
    }, { passive: true });
  })();

  /* ---------- click the wordmark 5x -> Dragonborn ---------- */
  (function () {
    var logo = document.querySelector('.header__heading-link, .header__heading'), n = 0, last = 0;
    if (!logo) return;
    logo.addEventListener('click', function () {
      var now = Date.now(); if (now - last > 1500) n = 0; last = now;
      if (++n >= 5) { n = 0; doShout('DOVAHKIIN', SHOUTS.dovahkiin[1]); toast('ACHIEVEMENT · you found the Thu’um', '🐉'); }
    });
  })();

  /* ---------- add-to-cart -> skill increased ---------- */
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches('form[action*="/cart/add"], [data-type="add-to-cart-form"], .rpg-satc__pf')) {
      skillUp();
      var btn = e.target.querySelector('[name="add"], button[type="submit"], .rpg-satc__btn') || e.target;
      absorbSoul(btn);
    }
  }, true);

  /* ---------- MOBILE eggs (no keyboard needed) ---------- */
  var SK_KEYS = Object.keys(SHOUTS);
  function randomShout() { var k = SK_KEYS[Math.floor(Math.random() * SK_KEYS.length)]; doShout(SHOUTS[k][0], SHOUTS[k][1]); }
  // triple-tap anywhere -> shout
  (function () {
    var taps = [];
    addEventListener('touchend', function (e) {
      var t = e.target; if (t && (t.closest('a,button,input,textarea,select,summary,[role="button"]'))) return;
      var now = Date.now(); taps.push(now); taps = taps.filter(function (x) { return now - x < 700; });
      if (taps.length >= 3) { taps = []; randomShout(); }
    }, { passive: true });
  })();
  // shake the phone -> shout (Android; iOS needs a permission gesture we don't force)
  (function () {
    if (typeof DeviceMotionEvent === 'undefined' || (DeviceMotionEvent.requestPermission && !window.__skMotionOk)) return;
    var last = 0, lx = 0, ly = 0, lz = 0;
    addEventListener('devicemotion', function (e) {
      var a = e.accelerationIncludingGravity; if (!a) return;
      var now = Date.now(); if (now - last < 900) return;
      var d = Math.abs(a.x - lx) + Math.abs(a.y - ly) + Math.abs(a.z - lz);
      lx = a.x; ly = a.y; lz = a.z;
      if (d > 42) { last = now; randomShout(); }
    });
  })();

  /* ---------- idle guard line ---------- */
  (function () {
    var lines = ['let me guess. someone stole your sweetroll.', 'no lollygagging.', 'wait... I know you.', 'you there. halt.', 'by the gods.'], idle;
    function reset() { clearTimeout(idle); idle = setTimeout(function () { toast(lines[Math.floor(Math.random() * lines.length)], '🛡'); reset(); }, 45000); }
    ['mousemove', 'keydown', 'scroll', 'touchstart'].forEach(function (ev) { addEventListener(ev, reset, { passive: true }); });
    reset();
  })();

  /* ---------- rotating band tips (from the lore band) ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var host = document.querySelector('[data-sky-tips]'); if (!host) return; var arr;
    try { arr = JSON.parse(host.getAttribute('data-sky-tips')); } catch (e) { return; }
    if (!arr || !arr.length) return; var i = 0; host.textContent = arr[0];
    if (reduce || arr.length < 2) return;
    setInterval(function () { i = (i + 1) % arr.length; host.style.opacity = '0'; setTimeout(function () { host.textContent = arr[i]; host.style.opacity = '1'; }, 320); }, 5400);
  }, { once: true });

  /* ---------- Skyrim dev console (~ on desktop · swipe-konami on mobile) ---------- */
  (function () {
    var box, logEl, field, open = false;
    function build() {
      box = document.createElement('div');
      box.className = 'sk-console';
      box.innerHTML =
        '<div class="sk-console__box" role="dialog" aria-label="console">' +
        '<div class="sk-console__bar"><span>~ console</span><button class="sk-console__x" type="button" aria-label="close">esc</button></div>' +
        '<div class="sk-console__log"></div>' +
        '<form class="sk-console__inp"><span class="sk-console__prompt">&gt;</span>' +
        '<input class="sk-console__field" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" placeholder="type a command  ·  try: help"></form>' +
        '</div>';
      document.body.appendChild(box);
      logEl = box.querySelector('.sk-console__log');
      field = box.querySelector('.sk-console__field');
      box.querySelector('.sk-console__x').addEventListener('click', close);
      box.addEventListener('click', function (e) { if (e.target === box) close(); });
      box.querySelector('.sk-console__inp').addEventListener('submit', function (e) { e.preventDefault(); run(field.value); field.value = ''; });
      print('RPG COUNTRY console. the hold hears you.', 'sys');
      print('type <b>help</b> for commands.', 'sys');
    }
    function print(txt, cls) { var p = document.createElement('div'); if (cls) p.className = cls; p.innerHTML = txt; logEl.appendChild(p); logEl.scrollTop = logEl.scrollHeight; }
    function openC() { if (!box) build(); box.classList.add('is-open'); open = true; setTimeout(function () { field.focus(); }, 60); }
    function close() { if (box) { box.classList.remove('is-open'); open = false; } }
    function esc(s) { return (s || '').replace(/</g, '&lt;'); }
    function run(raw) {
      var cmd = (raw || '').trim(); if (!cmd) return;
      print('<span class="cmd">&gt; ' + esc(cmd) + '</span>');
      var c = cmd.toLowerCase(), a = c.split(/\s+/)[0];
      if (a === 'help') print('fus · yol · iiz · feim · dovahkiin · tgm · tcl · coc · additem · code · sneak · clear');
      else if (SHOUTS[a]) { print('the words leave your throat.', 'ok'); close(); setTimeout(function () { doShout(SHOUTS[a][0], SHOUTS[a][1]); }, 180); }
      else if (a === 'tgm') print('god mode enabled. you were already invincible in this fit.', 'ok');
      else if (a === 'tcl') print('collision off. clip through the mundane.', 'ok');
      else if (a === 'coc') print(c.indexOf('whiterun') > -1 ? "you're already home." : "location not found in this realm.");
      else if (a === 'additem' || c.indexOf('player.additem') === 0) print('added: 1x mammoth long sleeve. (checkout still required, dovahkiin.)', 'ok');
      else if (a === 'code' || a === 'cheat' || a === 'console' || a === 'psst') { try { navigator.clipboard && navigator.clipboard.writeText(window.RPG_EGG_CODE || 'CONSOLE'); } catch (e) {} print('cheat code <b>CONSOLE</b> copied. 15% off at checkout.', 'ok'); }
      else if (a === 'sneak') print('sneak 100. no one saw you read this.', 'ok');
      else if (a === 'clear') logEl.innerHTML = '';
      else if (a === 'qqq') print("quitting... just kidding. you're staying in the hold.");
      else print("'" + esc(cmd) + "' is not a known shout. type help.");
    }
    window.RPGConsole = openC;
    // desktop: the ~ key (Skyrim's console key)
    addEventListener('keydown', function (e) {
      if (open) { if (e.key === 'Escape') close(); return; }
      var t = e.target; if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
      if (e.key === '~' || e.key === '`') { e.preventDefault(); openC(); }
    });
    // mobile: swipe the konami pattern ↑↑↓↓←→←→ (the horizontal part keeps normal scrolling from triggering it)
    var seq = [38, 38, 40, 40, 37, 39, 37, 39], pos = 0, sx = 0, sy = 0, last = 0;
    addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
    addEventListener('touchend', function (e) {
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 28 && Math.abs(dy) < 28) return;
      var now = Date.now(); if (now - last > 1500) pos = 0; last = now;
      var dir = Math.abs(dx) > Math.abs(dy) ? (dx > 0 ? 39 : 37) : (dy > 0 ? 40 : 38);
      pos = (dir === seq[pos]) ? pos + 1 : (dir === seq[0] ? 1 : 0);
      if (pos === seq.length) { pos = 0; openC(); toast('console unlocked', '~'); }
    }, { passive: true });
    // mobile-friendly: tap the footer "~" three times quickly
    var tTaps = 0, tLast = 0;
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('.rpg-tilde');
      if (!el) return;
      e.preventDefault();
      var now = Date.now(); if (now - tLast > 1200) tTaps = 0; tLast = now;
      if (++tTaps >= 3) { tTaps = 0; openC(); toast('console unlocked', '~'); }
    });
  })();

  /* ---------- console wink ---------- */
  try {
    console.log('%cFUS RO DAH', 'font:900 20px Georgia,serif;letter-spacing:.3em;color:#dfe3e8;background:#06070a;padding:6px 14px;');
    console.log('%c// type: fus · yol · iiz · feim · dovahkiin · sweetroll · cheese  ·  ↑↑↓↓←→←→ B A  ·  mobile: triple-tap or shake', 'font:12px ui-monospace,monospace;color:#7f95a8;');
  } catch (e) {}
})();
